import { isDefined } from '@sgme/fp';
import type { DealSplitData, DealSplitIndependentAmount } from 'models/forms/DealSplitData';

import type { DealSplitRowModel } from './types';

export const EMPTY_INDEPENDENT_AMOUNT: DealSplitIndependentAmount = {
  Type: undefined,
  Value: undefined,
  ValueDate: undefined,
};

export const hasIndependentAmountValues = (independentAmount?: DealSplitIndependentAmount | null): boolean =>
  isDefined(independentAmount?.Type) || isDefined(independentAmount?.Value) || isDefined(independentAmount?.ValueDate);

export const hasOtherRowsWithIndependentAmount = (dealSplits: DealSplitRowModel[], currentRowIndex: number): boolean =>
  dealSplits.some(
    ({ independentAmount }, rowIndex) => rowIndex !== currentRowIndex && hasIndependentAmountValues(independentAmount),
  );

export const patchDealSplitGridRow = (
  dealSplits: readonly DealSplitData[],
  rowIndex: number,
  patch: Partial<DealSplitData>,
): DealSplitData[] => [
  ...dealSplits.slice(0, rowIndex),
  { ...dealSplits[rowIndex], ...patch },
  ...dealSplits.slice(rowIndex + 1),
];

export const getIACurrency = (notionalCurrency: string, iaCurrency: Nullable<string>): string => {
  if (notionalCurrency === 'Units' && iaCurrency !== null) {
    return iaCurrency;
  }

  return notionalCurrency;
};
